import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import { Link } from '@mui/material';
import {useTranslation} from "react-i18next";
import i18n from "../../i18n.js";
import PublicIcon from '@mui/icons-material/Public';

export default function AppHeader({noLogo}) {
    let desktopLogoSrc = process.env.PUBLIC_URL + '/media/images/Logo_nuoDo_desktop_20256_new.svg';

    const {t} = useTranslation('translation');
    const fiLink = "https://nuorisotilastot.fi/nuodo-info/";
    const svLink = "https://nuorisotilastot.fi/sv/2489/uncategorized-sv/ungdo/";

    let lang = i18n.language === "fi" ? fiLink : svLink;

    const changeLanguage = (lng) => {
        localStorage.setItem('loc_id', lng);
        document.documentElement.lang = lng;
        i18n.changeLanguage(lng);
    };

    return (
        <Box sx={{ flexGrow: 1, width: '100%'}}>
            <AppBar position="static" sx={{backgroundColor: '#F5A89D !important'}}>
                <Toolbar className='toolbar-header' sx={{backgroundColor: '#F5A89D', height: '10vh', width: '50%', justifyContent: 'space-between' }}>
                    {noLogo ? (
                        <div className={'logo-container'}>
                            <Link className="header-logo" href="/" sx={{color: '#0A1D38'}}>
                                {t('login.to_frontpage')}
                            </Link>
                        </div>
                    ) : (
                        <div className={'logo-container'}>
                            <Link className="header-logo" href="/">
                                <img
                                    className="header-logo-normal"
                                    src={desktopLogoSrc}
                                    alt={t('common.youth_work')}
                                />
                            </Link>
                        </div>
                    )}
                    <Box>
                        <Link href={lang} target='_blank' sx={{color: '#0A1D38'}}>
                            {t('login.header_info')}
                        </Link>
                    </Box>
                    
                    <Button aria-label={i18n.language === 'fi' ? 'Vaihda sivuston kieli' : 'Byt sidan språk till svenska'} sx={{color: '#0A1D38'}} onClick={() => changeLanguage(i18n.language === "sv" ? "fi" : "sv")}>
                        <PublicIcon />
                        <span>{t(i18n.language === "sv" ? 'common.fi' : 'common.sv')}</span>
                    </Button>
                </Toolbar>
            </AppBar>
        </Box>
    );
    }